(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobistore-keyboard"]) return;
  try {
    
if (!customElements.get('mobistore-keyboard')) {
  customElements.define('mobistore-keyboard', class extends HTMLElement {
    connectedCallback() {
      this.onChange = () => this.updateOffer();
      this.onClick = event => {
        const colorButton = event.target.closest('[data-color]');
        if (colorButton && this.contains(colorButton)) {
          this.querySelectorAll('[data-color-opts] [data-color]').forEach(opt => { opt.setAttribute('aria-pressed', String(opt === colorButton)); });
          const color = colorButton.dataset.color;
          const idKey = color === 'Blanc' ? 'idBlanc' : 'idNoir';
          this.querySelectorAll('input[name=\"id\"]').forEach(input => { if (input.dataset[idKey]) input.value = input.dataset[idKey]; });
          return;
        }
        const button = event.target.closest('[data-gallery]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('[data-photo]').forEach(photo => { photo.hidden = photo.dataset.photo !== button.dataset.gallery; });
        this.querySelectorAll('[data-gallery]').forEach(control => { control.setAttribute('aria-pressed', String(control === button)); });
      };
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.updateOffer();
      const stage = this.querySelector('.mk__stage');
      if (stage) {
        let touchStartX = 0;
        stage.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0].screenX; }, { passive: true });
        stage.addEventListener('touchend', event => {
          const delta = event.changedTouches[0].screenX - touchStartX;
          if (Math.abs(delta) < 40) return;
          const buttons = Array.from(this.querySelectorAll('[data-gallery-nav] [data-gallery]'));
          if (!buttons.length) return;
          const activeIndex = buttons.findIndex(b => b.getAttribute('aria-pressed') === 'true');
          const nextIndex = delta < 0
            ? Math.min(activeIndex + 1, buttons.length - 1)
            : Math.max(activeIndex - 1, 0);
          if (nextIndex !== activeIndex) buttons[nextIndex].click();
        }, { passive: true });
      }
      this.querySelectorAll('[data-summary], [data-gallery-nav]').forEach(node => { node.hidden = false; });
      const offer = this.querySelector('.mk__order');
      const sticky = this.querySelector('[data-sticky]');
      if ('IntersectionObserver' in window && offer && sticky) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        this.observer.observe(offer);
      }
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const revealer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); } });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        this.querySelectorAll('.mk__reveal').forEach(el => revealer.observe(el));
      } else {
        this.querySelectorAll('.mk__reveal').forEach(el => el.classList.add('is-visible'));
      }
    }
    updateOffer() {
      const selected = this.querySelector('input[name="id"]:checked');
      if (!selected) return;
      ['price', 'delivery', 'total'].forEach(key => {
        this.querySelectorAll('[data-' + key + ']:not(input)').forEach(node => { node.textContent = selected.dataset[key]; });
      });
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      if (this.observer) this.observer.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
